import { type MCPServerInfo } from '../../types';

const IncidentioServer: MCPServerInfo = {
  serverId: 'INCIDENTIO',
  name: 'incident.io',
  slug: 'incidentio',
  description:
    'incident.io MCP Server for comprehensive incident management, alerts, workflows, and more',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.incident.io/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default IncidentioServer;
